module.exports = __webpack_public_path__ + "media/application/images/svgs/rotate-ccw-636f0d3cc3063a7bcff2b76c629c6356.svg";